"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Link from "next/link";
const details = [{
  num: "01",
  title: "Headquarters",
  subtitle: "Global Office & Operations",
  content: "203, 1st Floor, Block-A, Sangam River Apartment,\nVaruna Vihar Colony, Varanasi, UP 221002",
  action: "View on Map",
  link: "https://maps.google.com"
}, {
  num: "02",
  title: "Correspondence",
  subtitle: "Email & Press Inquiries",
  content: "info@girmitiyacouncil.in\nresearch@girmitiyacouncil.in",
  action: "Send an Email",
  link: "mailto:info@girmitiyacouncil.in"
}, {
  num: "03",
  title: "Telephone",
  subtitle: "Direct Lines & Support",
  content: "+91-94159 49494\nAvailable Mon-Fri, 10am - 6pm (IST)",
  action: "Call Now",
  link: "tel:+919415949494"
}, {
  num: "04",
  title: "Archive Hours",
  subtitle: "Digital & Physical Access",
  content: "Digital Archives: Accessible 24/7\nPhysical Records: By Appointment Only",
  action: "Browse Archives",
  link: "/archives"
}];
const ContactInfo = () => {
  const $ = _c(6);
  const [activeIndex, setActiveIndex] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[10.5px] tracking-[0.25em] uppercase text-[#DF6D2A] font-light">Contact Directory</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col md:flex-row md:items-end justify-between gap-5 sm:gap-8 mb-10 sm:mb-16"><div>{t0}<h2 className="font-display text-[34px] sm:text-[44px] md:text-[56px] font-light leading-[1.05] tracking-[-0.02em] text-[#0F1C2E]">Council <em className="text-[#C9A84C] italic">Registry</em></h2></div><p className="font-body text-[14px] sm:text-[15px] font-light leading-[1.7] sm:leading-[1.85] text-[#4C596B] max-w-[400px]">Select a department below to reveal direct contact information, operational hours, and physical locations.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeIndex) {
    t2 = details.map((item, index) => {
      const isActive = activeIndex === index;
      return <div key={index} onMouseEnter={() => setActiveIndex(index)} onMouseLeave={() => setActiveIndex(null)} onClick={() => setActiveIndex(isActive ? null : index)} className={`group relative border-b border-[#0F1C2E]/15 transition-colors duration-700 ease-out overflow-hidden cursor-pointer ${isActive ? "bg-[#0F1C2E] text-[#F4EFE6] shadow-2xl z-10" : "bg-transparent text-[#0F1C2E] z-0"}`}><div className="flex items-center justify-between py-6 sm:py-8 md:py-10 lg:py-14 px-4 sm:px-6 md:px-12 relative z-10"><div className="flex items-center gap-4 sm:gap-6 md:gap-8 lg:gap-16"><span className={`font-body text-[11px] md:text-[13px] tracking-[0.25em] transition-colors duration-500 ${isActive ? "text-[#C9A84C]" : "text-[#DF6D2A]"}`}>{item.num}</span><h3 className={`font-display text-[24px] sm:text-[36px] md:text-[48px] lg:text-[64px] font-light tracking-tight transition-transform duration-700 ease-out origin-left ${isActive ? "scale-[1.02]" : "scale-100"}`}>{item.title}</h3></div><div className={`w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 rounded-full border flex items-center justify-center transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${isActive ? "border-white/20 bg-white/5 rotate-0 scale-110" : "border-[#0F1C2E]/20 bg-transparent rotate-45 scale-100"}`}><ArrowUpRight strokeWidth={1} size={20} className={`transition-colors duration-500 ${isActive ? "text-[#F4EFE6]" : "text-[#0F1C2E]"}`} /></div></div><AnimatePresence>{isActive && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }} className="relative z-10"><div className="pb-8 sm:pb-10 md:pb-12 lg:pb-16 px-4 sm:px-6 md:px-12 lg:px-[120px] flex flex-col md:flex-row gap-5 sm:gap-6 md:gap-8 justify-between items-start md:items-end"><div><h4 className="font-body text-[11px] sm:text-[12px] uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#C9A84C] mb-3 sm:mb-4">{item.subtitle}</h4><p className="font-body text-[14px] sm:text-[16px] md:text-[18px] font-light text-[#F4EFE6]/70 whitespace-pre-line leading-[1.7] sm:leading-[1.8] max-w-[400px]">{item.content}</p></div>{item.link.startsWith("/") ? <Link href={item.link} className="inline-flex items-center gap-3 font-body text-[12.5px] font-medium tracking-[0.1em] uppercase text-[#F4EFE6] hover:text-[#DF6D2A] transition-colors border-b border-[#F4EFE6]/30 hover:border-[#DF6D2A] pb-1 group/link">{item.action}<ArrowUpRight size={14} className="transition-transform duration-300 group-hover/link:translate-x-1 group-hover/link:-translate-y-1" /></Link> : <a href={item.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 font-body text-[12.5px] font-medium tracking-[0.1em] uppercase text-[#F4EFE6] hover:text-[#DF6D2A] transition-colors border-b border-[#F4EFE6]/30 hover:border-[#DF6D2A] pb-1 group/link">{item.action}<ArrowUpRight size={14} className="transition-transform duration-300 group-hover/link:translate-x-1 group-hover/link:-translate-y-1" /></a>}</div></motion.div>}</AnimatePresence></div>;
    });
    $[2] = activeIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <section className="bg-[#F4EFE6] py-16 sm:py-24 md:py-32 relative z-10 border-t border-[#0F1C2E]/10"><div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8">{t1}<div className="flex flex-col border-t border-[#0F1C2E]/15">{t2}</div></div></section>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default ContactInfo;